<template>
  <v-combobox
    v-bind="$attrs"
    v-on="$listeners"
    :items="formesJuridique"
    @update:search-input="updateInputValue"
    :data-testid="dataTestid"
  />
</template>

<script>
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      formesJuridique: [
        { header: "Sélectionner une valeur, ou saisissez une valeur autre" },
        "EURL" ,
        "SARL" ,
        "Association",
      ],
    };
  },
  methods: {
    updateInputValue(value) {
      if(this.$attrs.value !== undefined) {
        // Mettre à jour la valeur saisie
        this.$emit("input", value);
      }
    }
  }
};
</script>
